import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import { and } from "truth-helpers";
import PluginOutlet from "discourse/components/plugin-outlet";
import icon from "discourse-common/helpers/d-icon";
import i18n from "discourse-common/helpers/i18n";
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export default class TopicStatus extends Component {
  static #_ = (() => dt7948.g(this.prototype, "currentUser", [service]))();
  #currentUser = (() => (dt7948.i(this, "currentUser"), void 0))();
  get canAct() {
    return this.currentUser && !this.args.disableActions;
  }
  togglePinned(e1) {
    const {
      topic: topic1
    } = this.args;
    topic1.pinned ? topic1.clearPin() : topic1.rePin();
    e1.preventDefault();
  }
  static #_2 = (() => dt7948.n(this.prototype, "togglePinned", [action]))();
  static #_3 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      {{~! no whitespace ~}}
      <span class="topic-statuses">
        {{~#if (and @topic.closed @topic.archived)~}}
          <span
            title={{i18n "topic_statuses.locked_and_archived.help"}}
            class="topic-status"
          >{{icon "lock"}}</span>
        {{~else if @topic.closed~}}
          <span
            title={{i18n "topic_statuses.locked.help"}}
            class="topic-status"
          >{{icon "lock"}}</span>
        {{~else if @topic.archived~}}
          <span
            title={{i18n "topic_statuses.archived.help"}}
            class="topic-status"
          >{{icon "lock"}}</span>
        {{~/if~}}
  
        {{~#if @topic.is_warning~}}
          <span
            title={{i18n "topic_statuses.warning.help"}}
            class="topic-status topic-status-warning"
          >{{icon "envelope"}}</span>
        {{~else if (and @showPrivateMessageIcon @topic.isPrivateMessage)~}}
          <span
            title={{i18n "topic_statuses.personal_message.help"}}
            class="topic-status"
          >{{icon "envelope"}}</span>
        {{~/if~}}
  
        {{~#if @topic.pinned~}}
          {{~#if this.canAct~}}
            <a
              {{on "click" this.togglePinned}}
              href
              title={{i18n "topic_statuses.pinned.help"}}
              class="topic-status"
            >{{icon "thumbtack"}}</a>
          {{~else~}}
            <span
              title={{i18n "topic_statuses.pinned.help"}}
              class="topic-status"
            >{{icon "thumbtack"}}</span>
          {{~/if~}}
        {{~else if @topic.unpinned~}}
          {{~#if this.canAct~}}
            <a
              {{on "click" this.togglePinned}}
              href
              title={{i18n "topic_statuses.unpinned.help"}}
              class="topic-status"
            >{{icon "thumbtack" class="unpinned"}}</a>
          {{~else~}}
            <span
              title={{i18n "topic_statuses.unpinned.help"}}
              class="topic-status"
            >{{icon "thumbtack" class="unpinned"}}</span>
          {{~/if~}}
        {{~/if~}}
  
        {{~#if @topic.invisible~}}
          <span
            title={{i18n
              "topic_statuses.unlisted.help"
              unlistedReason=@topic.visibilityReasonTranslated
            }}
            class="topic-status"
          >{{icon "far-eye-slash"}}</span>
        {{~/if~}}
  
        <PluginOutlet
          @name="after-topic-status"
          @outletArgs={{hash topic=this.topic}}
        />
        {{~! no whitespace ~}}
      </span>
      {{~! no whitespace ~}}
    
  */
  {
    "id": "vF4/PD9r",
    "block": "[[[10,1],[14,0,\"topic-statuses\"],[12],[41,[28,[32,0],[[30,1,[\"closed\"]],[30,1,[\"archived\"]]],null],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.locked_and_archived.help\"],null]],[14,0,\"topic-status\"],[12],[1,[28,[32,2],[\"lock\"],null]],[13]],[]],[[[41,[30,1,[\"closed\"]],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.locked.help\"],null]],[14,0,\"topic-status\"],[12],[1,[28,[32,2],[\"lock\"],null]],[13]],[]],[[[41,[30,1,[\"archived\"]],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.archived.help\"],null]],[14,0,\"topic-status\"],[12],[1,[28,[32,2],[\"lock\"],null]],[13]],[]],null]],[]]]],[]]],[41,[30,1,[\"is_warning\"]],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.warning.help\"],null]],[14,0,\"topic-status topic-status-warning\"],[12],[1,[28,[32,2],[\"envelope\"],null]],[13]],[]],[[[41,[28,[32,0],[[30,2],[30,1,[\"isPrivateMessage\"]]],null],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.personal_message.help\"],null]],[14,0,\"topic-status\"],[12],[1,[28,[32,2],[\"envelope\"],null]],[13]],[]],null]],[]]],[41,[30,1,[\"pinned\"]],[[[41,[30,0,[\"canAct\"]],[[[11,3],[24,6,\"\"],[16,\"title\",[28,[32,1],[\"topic_statuses.pinned.help\"],null]],[24,0,\"topic-status\"],[4,[32,3],[\"click\",[30,0,[\"togglePinned\"]]],null],[12],[1,[28,[32,2],[\"thumbtack\"],null]],[13]],[]],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.pinned.help\"],null]],[14,0,\"topic-status\"],[12],[1,[28,[32,2],[\"thumbtack\"],null]],[13]],[]]]],[]],[[[41,[30,1,[\"unpinned\"]],[[[41,[30,0,[\"canAct\"]],[[[11,3],[24,6,\"\"],[16,\"title\",[28,[32,1],[\"topic_statuses.unpinned.help\"],null]],[24,0,\"topic-status\"],[4,[32,3],[\"click\",[30,0,[\"togglePinned\"]]],null],[12],[1,[28,[32,2],[\"thumbtack\"],[[\"class\"],[\"unpinned\"]]]],[13]],[]],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.unpinned.help\"],null]],[14,0,\"topic-status\"],[12],[1,[28,[32,2],[\"thumbtack\"],[[\"class\"],[\"unpinned\"]]]],[13]],[]]]],[]],null]],[]]],[41,[30,1,[\"invisible\"]],[[[10,1],[15,\"title\",[28,[32,1],[\"topic_statuses.unlisted.help\"],[[\"unlistedReason\"],[[30,1,[\"visibilityReasonTranslated\"]]]]]],[14,0,\"topic-status\"],[12],[1,[28,[32,2],[\"far-eye-slash\"],null]],[13]],[]],null],[8,[32,4],null,[[\"@name\",\"@outletArgs\"],[\"after-topic-status\",[28,[32,5],null,[[\"topic\"],[[30,0,[\"topic\"]]]]]]],null],[13]],[\"@topic\",\"@showPrivateMessageIcon\"],false,[\"if\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/topic-status.js",
    "scope": () => [and, i18n, icon, on, PluginOutlet, hash],
    "isStrictMode": true
  }), this))();
}